import React from 'react';
import PropTypes from 'prop-types';

const OrganicShapeD = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 769 581">
      <path
        fill={props.color}
        d="M57.4061214,195.626322 C-22.4222425,322.769637 -18.9942281,411.723928 67.6901647,462.489194 C197.716754,538.637092 427.702898,446.872056 513.088676,462.489194 C598.474455,478.106331 552.409645,626.443826 639.248873,567.027809 C697.141691,527.417131 740.392067,434.205477 769,287.392847 L467.06457,0 L57.4061214,195.626322 Z"
      />
    </svg>
  );
};

OrganicShapeD.defaultProps = {
  color: '#000000',
};

OrganicShapeD.propTypes = {
  color: PropTypes.string,
};

export default OrganicShapeD;
